/**
 * Normalize typed answers for English practice.
 * - trim + collapse spaces
 * - smart quotes → ASCII
 * - case-insensitive unless caseSensitive
 */
export const normalizeTypedAnswer = (text, { caseSensitive = false } = {}) => {
  let value = String(text || "")
    .trim()
    .replace(/\s+/g, " ")
    .replace(/[\u2018\u2019\u02BC]/g, "'")
    .replace(/[\u201C\u201D]/g, '"')
    .replace(/\u2014|\u2013/g, "-");
  if (!caseSensitive) value = value.toLowerCase();
  // Ignore trailing punctuation for friendlier matching
  value = value.replace(/[.!?]+$/g, "");
  return value;
};

export const answersMatch = (input, answer, options = {}) => {
  const expected = Array.isArray(answer) ? answer : [answer];
  const normalizedInput = normalizeTypedAnswer(input, options);
  return expected.some(
    (item) => normalizeTypedAnswer(item, options) === normalizedInput
  );
};
